module.exports = {
    ADD_TO_CART: 'Add to Cart',
    REMOVE_FROM_CART: 'Remove from Cart',
    ADD_ALL: 'Add all',
    SAVE_TO_LIST: 'Save to list',
    SAVE_TROLLEY_LIST: 'Save trolley as list',
    VIEW_ALL_SIZES: 'View all sizes',
    KEEP_RECIPE: 'Keep',
    SIGN_UP: {
        START: 'Sign Up Start',
        END: 'Sign Up End',
        COMPLETED: 'Sign Up Completed',
        FAILURE: 'Sign Up Failed',
    },
    LOGIN: {
        START: 'Login Form Start',
        END: 'Login Form End',
        FORM_FILL_EMAIL_ADDRESS: 'Login Form Fill: EmailAddress',
        FORM_FILL_PASSWORD: 'Login Form Fill: Password',
        FORM_FILL_REMEMBER_ME: 'Login Form Fill: RememberMe',
        COMPLETED_MANUAL: 'Login Form Completed: Manual',
        COMPLETED_AUTO: 'Login Form Completed: Auto',
        FAILURE: 'Login Failed',
    },
    PRODUCT_STAMP: {
        SIZE_LARGE: 'Product Stamp Size: Large',
        SIZE_SMALL: 'Product Stamp Size: Small',
    },
    TOGGLE_PANEL: 'Toggle panel',
    SOCIAL_SHARE: {
        FACEBOOK: 'Social share: Facebook',
        TWITTER: 'Social share: Twitter',
        PINTEREST: 'Social share: Pinterest',
        GOOGLEPLUS: 'Social share: Google Plus',
    },
    BANNER_CLICK: 'Banners',
    CARDS_LIST_SORT_BY_MENU: 'Sort By Menu',
    PRINT_RECIPE: 'Print recipe',
    DISCOVER_MORE: 'Discover more',
    VIDEO_TRACK: 'Video Tracking',
    CONTINUE_SHOPPING: 'Continue shopping', // This event is for when the shopper press 'Continue shopping' at the top left of the page at checkout/hyf
    RETURN_TO_SHOPPING: 'Return to shopping', // This event is for when the shopper encounters an error in checkout header and clicks the 'Return to Shopping' link inside error
    RICH_RELEVANCE_TIMEOUT: 'RichRelevance timeout',
};



// WEBPACK FOOTER //
// ./src/analytics/events.constants.js